import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';  // Import the Leaflet CSS file
import styled from 'styled-components';

const OSMMap = () => {
    useEffect(() => {
      // Check if the map is already created
      const existingMap = document.getElementById('map')._leaflet_id;
  
      if (existingMap) return; // If map already exists, don't initialize again
  
      // Create a map centered at a specific location (e.g., Pilar, Philippines)
      const map = L.map('map').setView([9.3445, 123.5167], 12);  // Coordinates for Pilar, Bohol
  
      // Set up OpenStreetMap tile layer
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

    // Add markers for the various places
    const places = [
      { name: 'Mahayag, San Miguel, Bohol', coordinates: [9.7869, 123.7535] },
      { name: 'Dagohoy, Bohol', coordinates: [9.9361, 123.7279] },
      { name: 'Pilar, Bohol', coordinates: [9.3445, 123.5167] },
      { name: 'Alicia, Bohol', coordinates: [9.5858, 123.7265] },
      { name: 'Talibon, Bohol', coordinates: [10.1353, 124.0403] },
    ];

    // Loop through the places and add a marker for each
    places.forEach(place => {
      L.marker(place.coordinates)
        .addTo(map)
        .bindPopup(`Irrigator in ${place.name}`)  // Custom popup for each place
        .openPopup();
    });

    // Cleanup function to remove the map on unmount
    return () => {
      map.remove();  // This ensures the map is properly removed when the component unmounts
    };
  }, []);  // Empty dependency array means this runs once when the component mounts

  return (
    <MapContainer>
    <Title>Bohol Irrigators </Title>
    <MapWrapper>
      <div id="map" style={{ height: '100%', width: '100%' }}></div>
    </MapWrapper>
  </MapContainer>
  );
};

const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 55%;
  height:40%;
  border-radius: 8px;
  margin-top:52%;
  background: linear-gradient(45deg,rgb(21, 182, 21),rgb(75, 238, 137));
 
`;

const MapWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;  /* Enable both vertical and horizontal scrolling */
  display: flex;
  justify-content: center;  /* To center the map if necessary */
  align-items: center;
`;

const Title = styled.h2`
  color: white;
  font-size: 1rem;
  margin-bottom: 10px;
  text-align: center;
`;

export default OSMMap;
